import { useTranslation } from "react-i18next";
import { MyRoute } from "./models/route";
import Research from "./pages/Research/Research";
import People from "./pages/People";
import CoursesTheses from "./pages/CoursesTheses";
import Contact from "./pages/Contact";

export default function RoutesList(): MyRoute[] {
  const { t } = useTranslation();

  return [
    { name: t("research"), route: "/research/*", component: <Research /> },
    { name: t("people"), route: "/people", component: <People /> },
    { name: t("coursesTheses"), route: "/courses-theses", component: <CoursesTheses /> },
    { name: t("contact"), route: "/contact", component: <Contact /> },
  ];
}
